import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { extendedTestimonials, stats, testimonials } from '../data/testimonials';
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-167" data-mp="3gr9fzzylzkl8">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-168" data-mp="3bqlold6gx1qh" />)}
    </div>;
}
export function StatsAndProof() {
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-169" data-mp="3lpujc895qkdw">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-170" data-mp="3btwe4i5y993">
          {stats.map(({
          value,
          label
        }) => <div key={label} className="text-center" data-id="element-171" data-mp="3vf4btp7wy52j">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-172" data-mp="3vhqqe8t81ku9">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-173" data-mp="daaqvbgb95zw">
                {label}
              </p>
            </div>)}
        </div>
      </section>
      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-174" data-mp="1gefr66o3w2sh">
        <div className="mx-auto max-w-6xl" data-id="element-175" data-mp="1lb63qk0pcg95">
          <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-176" data-mp="1lc7o5f3lyf3j">
            💬 LO QUE DICEN LAS CUIDADORAS
          </h2>
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4" data-id="element-177" data-mp="1udp2arxgg6pl">
            {testimonials.map(({
            initials,
            name,
            place,
            quote
          }, index) => <motion.article key={name} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-178" data-mp="1z9wakrdbpuap" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-179" data-mp="2i3t8n7212kka">
                  <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-180" data-mp="2n0s17l61mjgd">
                    {initials}
                  </div>
                  <div data-id="element-181" data-mp="iy03aekc5v0i">
                    <h3 className="font-bold" data-id="element-182" data-mp="iyrp4xo4sedl">{name}</h3>
                    <p className="text-sm text-slate-400" data-id="element-183" data-mp="wolfxlj758py">{place}</p>
                  </div>
                </div>
                <div className="mt-5" data-id="element-184" data-mp="rxmw4bz01shy">
                  <Stars data-id="element-185" data-mp="rwlnsf9dbk3x" />
                </div>
                <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-186" data-mp="16msujxq0jeos">“{quote}”</p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-187" data-mp="1fmfzgthyb2ml">
      <div className="mx-auto max-w-5xl" data-id="element-188" data-mp="1appje665c716">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-189" data-mp="1amjv2t5cd96i">
          LO QUE DICEN LAS CUIDADORAS
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-190" data-mp="3ch2jmhx65qqw">
          {extendedTestimonials.map(({
          name,
          place,
          quote
        }) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-191" data-mp="1ryiah1qmptji">
              <Stars data-id="element-192" data-mp="1ww0dkbhytejl" />
              <p className="mt-2 font-bold" data-id="element-193" data-mp="1wwa17sfjf9m4">
                {name} <span className="font-normal text-slate-400" data-id="element-194" data-mp="1j66mrnmwgk78">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-195" data-mp="1n6qhylnwxdqq">{quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}